import Observer from '../classes/Observer';

class ScrollReveal extends Observer {
  constructor($targets = $()) {
    super({
      isOnce: true,
      rootMargin: '0px 0px -15% 0px',
    });
    this.$targets = $targets;

    if ('IntersectionObserver' in window) {
      this.$targets.each((i, target) => {
        this.observer.observe(target);
      });
    } else {
      this.animateIn();
    }
  }

  revealTargets($els) {
    $els.each((i, target) => {
      this.observer.observe(target);
    });
  }

  animateIn(target) {
    super.animateIn();
    target.classList.add('is-visible');
  }
}

export default ScrollReveal;
